import {
  IonButton,
  IonCol,
  IonContent,
  IonHeader,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useAuth } from "../../api/auth";
import "./login.css";
import UserButton from "../../components/UserButton";
import CodeInput from "../../components/CodeInput";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";

const Login: React.FC = () => {
  let auth = useAuth();

  const history = useHistory();

  const [digits, setDigits] = useState(Array(6).fill(""));
  const [error, setError] = useState<null | boolean>(null);

  const login = async () => {
    const response = await auth.login({
      username: digits.join(""),
      password: digits.join(""),
    });

    if (response.token) {
      setError(false);
      history.push("/");
    } else {
      setError(true);
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary" className="Login-toolbar">
          <IonTitle>Connexion</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent className="Login-content">
        <div className="Login">
          <div className="Login-user">
            <UserButton></UserButton>
          </div>
          <div className="Login-text">Saisir mon code personnel</div>

          <IonRow>
            <CodeInput digits={digits} setDigits={setDigits} />
          </IonRow>
          {error ? (
            <div className="Login-error">Le code est invalide</div>
          ) : null}
          <IonButton
            onClick={async () => await login()}
            color="success"
            className="Login-button"
          >
            Se connecter
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Login;
